import { BREAKPOINTS, Heart } from '@classy/campaign-page-blocks'
import { css } from '@emotion/react'
import styled from '@emotion/styled'

export interface StickyDrawerProps {
  isVisible?: boolean
}

const slideInOutCss = (isVisible?: boolean, port: 'y' | 'x' = 'y') => css`
  transform: translate${port}(${isVisible ? '0%' : '100%'});
  opacity: ${isVisible ? 1 : 0};
  pointer-events: ${isVisible ? 'auto' : 'none'};
  transition:
    transform 420ms cubic-bezier(0.22, 1, 0.36, 1),
    opacity 300ms ease-out;
  will-change: transform;
`

export const StickyDrawer = styled.div<StickyDrawerProps>`
  @media (max-width: ${BREAKPOINTS.tablet}px) {
    display: flex;
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    width: 100%;
    height: 100px;
    padding-block: 12px;
    padding-inline: 16px;
    justify-content: center;
    align-items: start;
    background-color: var(--classy-color__neutral--100);
    box-shadow: 0 0 20px 0 rgba(35, 35, 35, 0.1);
    // animate in-out from the bottom
    ${(p) => slideInOutCss(p.isVisible, 'y')}
  }

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    display: flex;
    position: fixed;
    left: auto;
    right: 40px;
    bottom: 40px;
    z-index: 1000;
    width: fit-content;
    height: fit-content;
    padding-block: 0px;
    padding-inline: 0px;
    justify-content: center;
    align-items: start;
    border-radius: var(--classy-border__radius-lg);
    // animate in-out from the right
    ${(p) => slideInOutCss(p.isVisible, 'x')}
  }
`

export const StickyCtaButton = styled.button`
  display: flex;
  gap: 8px;
  justify-content: center;
  align-items: center;
  width: 100%;
  padding-block: 12px;
  padding-inline: 24px;
  font-family: var(--theme-font__font-family--general);
  font-size: var(--classy-font__paragraph-md--font-size);
  line-height: var(--classy-font__paragraph-lg-bold--line-height);
  font-weight: var(--classy-font__paragraph-lg-bold--font-weight);
  color: var(--classy-color__neutral--100);
  background-color: #000;
  border-radius: var(--classy-border__radius-lg);
  border: unset;
  overflow: hidden;
  cursor: pointer;

  @media (min-width: ${BREAKPOINTS.tablet}px) {
    padding-block: 16px;
  }
`

export const StickyCtaButtonIcon = styled(Heart)`
  path {
    fill: #de1004;
    stroke: #de1004;
  }
  animation-name: pulse;
  animation-play-state: running;
  animation-duration: 1800ms;
  animation-delay: 2000ms;
  animation-iteration-count: infinite;
  animation-timing-function: ease-in-out;
  @keyframes pulse {
    0%,
    25% {
      transform: scale(1);
    }
    50%,
    75% {
      transform: scale(1.25);
    }
    100% {
      transform: scale(1);
    }
  }
`
